import { render, staticRenderFns } from "./BeautyLogin.vue?vue&type=template&id=11f99666&scoped=true&"
import script from "./BeautyLogin.vue?vue&type=script&lang=js&"
export * from "./BeautyLogin.vue?vue&type=script&lang=js&"
import style0 from "./BeautyLogin.vue?vue&type=style&index=0&id=11f99666&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f99666",
  null
  
)

export default component.exports